import "@splidejs/splide/css/core";
import Splide from "@splidejs/splide";

var slider = document.querySelector(".home-experience .services");

if( slider ) {
    new Splide(slider, {
        type: "slider",
        perPage: 9,
        perMove: 1,
        arrows: false,
        pagination: false,
        drag: false,
        breakpoints: {
            900: {
                perPage: 4,
                perMove: 1,
            },
            600: {
                drag: true,
                perPage: 1,
                perMove: 1,
            }
        },
    }).mount();
}